import * as React from "react";
const SvgTask20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M19 1H1v18h18V1ZM3 17V3h14v14H3Zm5.5-2.586 6.707-6.707-1.414-1.414L8.5 11.586 6.207 9.293l-1.414 1.414L8.5 14.414Z",
      clipRule: "evenodd"
    })
  );
export default SvgTask20Px;
